import { registerComponent } from '@gig/magic-common';
import FreecoinsTransactionsComponent from './freecoins.vue.js';

var FreecoinTransactions = registerComponent(FreecoinsTransactionsComponent);

export { FreecoinTransactions };
